import { render, staticRenderFns } from "./customerContactChannel.vue?vue&type=template&id=35c50b80&"
import script from "./customerContactChannel.vue?vue&type=script&lang=js&"
export * from "./customerContactChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c50b80')) {
      api.createRecord('35c50b80', component.options)
    } else {
      api.reload('35c50b80', component.options)
    }
    module.hot.accept("./customerContactChannel.vue?vue&type=template&id=35c50b80&", function () {
      api.rerender('35c50b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/CrmSetting/customerContactChannel.vue"
export default component.exports